import { type Country, resolveCurrency } from 'services/i18n';

export function resolveInitialLocalization(initialCountry?: Country) {
  const country = initialCountry;

  return {
    country,
    currency: resolveCurrency(country),
  };
}
